<template>
  <RouterView />
</template>

<script>
import { READ, UPDATE } from '@/plugins/user'
export default {
  data () {
    return {
      breadcrumb: {
        name: new Promise((resolve) => {
          this.$sdk
            .team
            .read(this.$route.params.teamId, (builder) => {
              builder.context = { resource: 'account', id: this.$route.params.accountId }
            })
            .then((response) => {
              resolve(response.name)
            })
        }),
        route: { name: 'manage-accounts-account-configurations-teams-team', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } }
      },
      sidebar: [
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'users'],
          route: { name: 'manage-accounts-account-configurations-teams-team-profiles', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } },
          name: 'Attached Users'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'cogs'],
          route: { name: 'manage-accounts-account-configurations-teams-team-shippersettings', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } },
          name: 'Application Settings'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'envelope'],
          route: { name: 'manage-accounts-account-configurations-teams-team-eventtemplates', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } },
          name: 'Event Templates'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'book'],
          route: { name: 'manage-accounts-account-configurations-teams-team-blockedautobooks', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } },
          name: 'Blocked Autobooks'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'eye-slash'],
          route: { name: 'manage-accounts-account-configurations-teams-team-hideservices', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } },
          name: 'Hidden Services'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'id-badge'],
          route: { name: 'manage-accounts-account-configurations-teams-team-clients', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } },
          name: 'API Clients'
        }
      ]
    }
  }
}
</script>
